module.exports = __webpack_public_path__ + "img/gera2.jpg";